import clsx from 'clsx'
import Link from 'next/link'
import Image from 'next/image'

import WidthLimiter from 'containers/width-limiter/width-limiter'
import ScrollArea from 'containers/scroll-area/scroll-area'

import { STATIC_URL } from 'constants/data'

import styles from './intro-why-us.module.scss'
import stylesCommon from 'styles/main.module.scss'

const imgPath = {
  arrow: `${STATIC_URL}/intro-alt/necessary/arrow-link.png`,
  card1: `${STATIC_URL}/intro-alt/necessary/card-1-us.png`,
  card2: `${STATIC_URL}/intro-alt/necessary/card-2-us.png`,
  card3: `${STATIC_URL}/intro-alt/necessary/card-3-us.png`,
}

const dataTxt = [
  {
    title: 'Решение сложных клинических случаев',
    subtitle: 'Обсуждайте сложные клинические кейсы и задавайте вопросы ведущим специалистам',
    class: styles.card1,
    link: 'https://medpoint.pro/medpulse',
    imgInfo: {
      src: imgPath.card1,
      width: 138,
      height: 94,
      alt: 'Сообщество профессионалов',
    },
  },
  {
    title: 'Экономия времени',
    subtitle:
      'AI-помощник AI Bolit мгновенно находит нужную информацию из актуальных клинических рекомендаций',
    class: styles.card2,
    link: 'https://medpoint.pro/ai-medicus/landing',
    imgInfo: {
      src: imgPath.card2,
      width: 201,
      height: 95,
      alt: 'AIBolit — ИИ-сервис',
    },
  },
  {
    title: 'Актуальные знания от практикующих экспертов',
    subtitle: 'Вебинары, статьи и видео с фокусом на реальную клиническую практику',
    class: styles.card3,
    link: 'https://medpoint.pro/library',
    imgInfo: {
      src: imgPath.card3,
      width: 181,
      height: 88,
      alt: 'Разнообразное образование',
    },
  },
]

const IntroWhyUs = () => {
  return (
    <WidthLimiter noBottomPadding noTopPadding>
      <h2 className={stylesCommon.title}>Как Medpoint помогает в работе врача</h2>
      <ScrollArea isHiddenScrollbar modificator={styles.scrollWrap}>
        <div className={styles.cardsWrap}>
          {dataTxt.map((item, index) => {
            return (
              <div className={clsx(item.class, styles.card)} key={index}>
                <h3 className={styles.title} dangerouslySetInnerHTML={{ __html: item.title }}></h3>
                <div
                  className={styles.subtitle}
                  dangerouslySetInnerHTML={{ __html: item.subtitle }}
                ></div>
                <Link href={item.link} target="_blank">
                  <div className={clsx(styles.arrowWrap, { [styles.bodrerArrow]: index === 1 })}>
                    <Image src={imgPath.arrow} width={24} height={24} alt="arrow" />
                  </div>
                </Link>
                <Image {...item.imgInfo} />
              </div>
            )
          })}
        </div>
      </ScrollArea>
    </WidthLimiter>
  )
}

export default IntroWhyUs
